var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',_vm._l((this.events),function(event,index,key){return _c('b-col',{key:'col_'+index,attrs:{"cols":"12","md":( index == 0 ? 12 : 4 )}},[_c('event-box',{attrs:{"event":event,"index":index}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }